// extracted by mini-css-extract-plugin
export var activeFilterButton = "_py-c";
export var backButton = "_py-4";
export var backIcon = "_py-5";
export var chevronShortcut = "_py-6";
export var container = "_py-1";
export var editor = "_py-8";
export var editorWrapper = "_py-7";
export var prefix = "_py-2";
export var searchIcon = "_py-3";
export var suffix = "_py-9";
export var suffixContent = "_py-a";
export var suffixText = "_py-b";
export var wrapper = "_py-0";